/*
Don't change this file manually.
It is autogenerated by @plone/registry.
Instead, change the "addons" registration in the app.
*/

const projectConfigLoader = require('@root/config');
import plonevoltoSlate from '@plone/volto-slate';
import voltoPatentmanager from 'volto-patentmanager';

const addonsInfo = [{"name":"@plone/volto-slate","version":"18.9.0","isPublishedPackage":true,"isRegisteredAddon":false,"modulePath":"/home/admin/src/plone-project/patent-manager-site/frontend/core/packages/volto-slate/src","packageJson":"/home/admin/src/plone-project/patent-manager-site/frontend/core/packages/volto-slate/package.json","basePath":"/home/admin/src/plone-project/patent-manager-site/frontend/core/packages/volto-slate","tsConfigPaths":null,"addons":[]},{"name":"volto-patentmanager","version":"0.1.0","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/home/admin/src/plone-project/patent-manager/frontend/packages/volto-patentmanager/src","packageJson":"/home/admin/src/plone-project/patent-manager/frontend/packages/volto-patentmanager/package.json","basePath":"/home/admin/src/plone-project/patent-manager/frontend/packages/volto-patentmanager","tsConfigPaths":[null,{"@plone/volto/*":["../../../../patent-manager-site/frontend/core/packages/volto/src/*"],"volto-patentmanager/*":["./src/*"]}],"addons":[]}];
export { addonsInfo };

const safeWrapper = (func) => (config) => {
  const res = func(config);
  if (typeof res === 'undefined') {
    throw new Error("Configuration function doesn't return config");
  }
  return res;
}


const projectConfig = (config) => {
  return projectConfigLoader && typeof projectConfigLoader.default === "function" ? projectConfigLoader.default(config) : config;
}

const load = (config) => {
  const addonLoaders = [plonevoltoSlate, voltoPatentmanager];
  if(!addonLoaders.every((el) => typeof el === "function")) {
    throw new TypeError(
      'Each addon has to provide a function applying its configuration to the projects configuration.',
    );
  }
  return projectConfig(addonLoaders.reduce((acc, apply) => safeWrapper(apply)(acc), config));
};
export default load;
